import React, { useRef } from 'react';
var VeltNotificationsPanelContentAllListItemContent = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-all-list-item-content", { ref: ref }, children));
};
export default VeltNotificationsPanelContentAllListItemContent;
